import { useEffect } from 'react';
import { trackPageView } from '../api/tracker';

/**
 * Drop-in replacement for the previous VisitorTracker.
 *
 * Same usage — <VisitorTracker page="home" /> — but the de-duplication now
 * lives in the tracker module and is per session rather than a 30-minute
 * localStorage timestamp per page. That fixes two things: a visitor who
 * returns the next day is counted again, and the recorded view now carries the
 * channel, campaign and session id the console needs for attribution.
 */
const VisitorTracker = ({ page, title }) => {
  useEffect(() => {
    if (!page) return;
    trackPageView(page, { title });
  }, [page, title]);

  return null;
};

export default VisitorTracker;
